import { render, staticRenderFns } from "./NicheSalesForm.vue?vue&type=template&id=796bdf8f&"
import script from "./NicheSalesForm.vue?vue&type=script&lang=js&"
export * from "./NicheSalesForm.vue?vue&type=script&lang=js&"
import style0 from "./NicheSalesForm.vue?vue&type=style&index=0&id=796bdf8f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports